import { createContext, useContext } from 'react';
import { IQuestionnaire } from '../modules/unsw-fhir/Questionnaire';

export interface IQuestionnaireContext {
  questionnaire?: IQuestionnaire;
  error?: string;
  setQuestionnaire: (questionnaire: IQuestionnaire) => void;
  getQuestionnaireName: () => string;
  getQuestionnaireTitle: () => string;
  loading?: boolean;
}

export const initialQuestionnaireContext: IQuestionnaireContext = {
  setQuestionnaire: () => {},
  getQuestionnaireName: () => 'Unknown',
  getQuestionnaireTitle: () => 'Unknown',
};

export const QuestionnaireContext = createContext<IQuestionnaireContext>(
  initialQuestionnaireContext,
);

export const useQuestionnaire = () => {
  const questionnaire = useContext(QuestionnaireContext);

  return questionnaire;
};
